import { usePathname } from 'next/navigation'
import Link from 'next/link'

export function Solution() {
  const pathname = usePathname()

  return (
    <section>
      <div className="mx-auto w-full px-6 xl:px-0 py-16 lg:pt-32 lg:pb-0 lg:max-w-[1200px]">
        <h2 className="text-center text-lg lg:text-4xl text-textblack font-bold">
          ソリューション
        </h2>
        <p className="text-center text-base text-darken mt-6 leading-7">
          LAWGUEはあらゆるドキュメント作成を驚くほど効率化することができます。
          <br />
          利用シーンに合わせたソリューションをご紹介します。
        </p>
        {pathname === '/contract/' && (
          <div className="flex flex-wrap justify-center gap-10 mt-6 lg:mt-14">
            <div className="text-center w-full lg:max-w-[31%] bg-white py-6 lg:py-10 px-8 border rounded-lg border-gray">
              <div className="flex justify-center flex-col-reverse items-center">
                <img
                  decoding="async"
                  src="/images/solution/img_solution02.webp"
                  alt=""
                  className="w-auto h-full"
                />
              </div>

              <h3 className="text-center text-lg text-primary font-bold mt-0 lg:mt-2">
                規程・マニュアル管理
              </h3>

              <p className="text-center text-sm lg:text-base text-textblack mt-3">
                規程管理をクラウドで
                <br />
                効率化できます
              </p>
              <Link
                href="/regulation"
                className="pagescroll block base_button linkbutton__large button__hidden undefined transition hover:text-secondary hover:border-secondary mt-4 text-center"
              >
                詳しく見る
              </Link>
            </div>

            <div className="text-center w-full lg:max-w-[31%] bg-white py-6 lg:py-10 px-8 border rounded-lg border-gray">
              <div className="flex justify-center flex-col-reverse items-center">
                <img
                  decoding="async"
                  src="/images/solution/img_solution04.webp"
                  alt=""
                  className="w-auto h-full"
                />
              </div>

              <h3 className="text-center text-lg text-primary font-bold mt-0 lg:mt-2">
                英文契約書レビュー
              </h3>

              <p className="text-center text-sm lg:text-base text-textblack mt-3">
                対訳辞書登録で正確な
                <br />
                翻訳を実現します
              </p>
              <Link
                href="/translation"
                className="pagescroll block base_button linkbutton__large button__hidden undefined transition hover:text-secondary hover:border-secondary mt-4 text-center"
              >
                詳しく見る
              </Link>
            </div>

            <div className="text-center w-full lg:max-w-[31%] bg-white py-6 lg:py-10 px-8 border rounded-lg border-gray">
              <div className="flex justify-center flex-col-reverse items-center">
                <img
                  decoding="async"
                  src="/images/solution/img_solution03.webp"
                  alt=""
                  className="w-auto h-full"
                />
              </div>

              <h3 className="text-center text-lg text-primary font-bold mt-0 lg:mt-2">
                法令改正対応
              </h3>

              <p className="text-center text-sm lg:text-base text-textblack mt-3">
                最新の法改正情報を受け取り
                <br />
                法改正に迅速に対応します
              </p>
              <Link
                href="/law"
                className="pagescroll block base_button linkbutton__large button__hidden undefined transition hover:text-secondary hover:border-secondary mt-4 text-center"
              >
                詳しく見る
              </Link>
            </div>

            <div className="text-center w-full lg:max-w-[31%] bg-white py-6 lg:py-10 px-8 border rounded-lg border-gray">
              <div className="flex justify-center flex-col-reverse items-center">
                <img
                  decoding="async"
                  src="/images/solution/img_solution05.webp"
                  alt=""
                  className="w-auto h-full"
                />
              </div>

              <h3 className="text-center text-lg text-primary font-bold mt-0 lg:mt-2">
                D1-LAWGUE
              </h3>

              <p className="text-center text-sm lg:text-base text-textblack mt-3">
                次世代クラウドエディタで行政文書のDXを推進します
              </p>

              <p className="mt-4 text-center base_button_d1link">
                <Link
                  href="https://d1.lawgue.com/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="block text-center transition hover:text-secondary hover:border-secondary base_button linkbutton__large button__hidden"
                >
                  詳しく見る
                </Link>
              </p>
            </div>
          </div>
        )}
        {pathname === '/law/' && (
          <div className="flex flex-wrap justify-center gap-10 mt-6 lg:mt-14">
            <div className="text-center w-full lg:max-w-[31%] bg-white py-6 lg:py-10 px-8 border rounded-lg border-gray">
              <div className="flex justify-center flex-col-reverse items-center">
                <img
                  decoding="async"
                  src="/images/solution/img_solution01.webp"
                  alt=""
                  className="w-auto h-full"
                />
              </div>
              <h3 className="text-center text-lg text-primary font-bold mt-0 lg:mt-2">
                契約ナレッジマネジメント
              </h3>
              <p className="text-center text-sm lg:text-base text-textblack mt-3">
                契約書業務の時間を大幅に
                <br />
                削減します
              </p>
              <Link
                href="/contract"
                className="pagescroll block base_button linkbutton__large button__hidden undefined transition hover:text-secondary hover:border-secondary mt-4 text-center"
              >
                詳しく見る
              </Link>
            </div>

            <div className="text-center w-full lg:max-w-[31%] bg-white py-6 lg:py-10 px-8 border rounded-lg border-gray">
              <div className="flex justify-center flex-col-reverse items-center">
                <div></div>
                <img
                  decoding="async"
                  src="/images/solution/img_solution02.webp"
                  alt=""
                  className="w-auto h-full"
                />
              </div>
              <h3 className="text-center text-lg text-primary font-bold mt-0 lg:mt-2">
                規程・マニュアル管理
              </h3>
              <p className="text-center text-sm lg:text-base text-textblack mt-3">
                規程管理をクラウドで
                <br />
                効率化できます
              </p>
              <Link
                href="/regulation"
                className="pagescroll block base_button linkbutton__large button__hidden undefined transition hover:text-secondary hover:border-secondary mt-4 text-center"
              >
                詳しく見る
              </Link>
            </div>

            <div className="text-center w-full lg:max-w-[31%] bg-white py-6 lg:py-10 px-8 border rounded-lg border-gray">
              <div className="flex justify-center flex-col-reverse items-center">
                <div></div>
                <img
                  decoding="async"
                  src="/images/solution/img_solution04.webp"
                  alt=""
                  className="w-auto h-full"
                />
              </div>
              <h3 className="text-center text-lg text-primary font-bold mt-0 lg:mt-2">
                英文契約書レビュー
              </h3>
              <p className="text-center text-sm lg:text-base text-textblack mt-3">
                対訳辞書登録で正確な
                <br />
                翻訳を実現します
              </p>
              <Link
                href="/translation"
                className="pagescroll block base_button linkbutton__large button__hidden undefined transition hover:text-secondary hover:border-secondary mt-4 text-center"
              >
                詳しく見る
              </Link>
            </div>

            <div className="text-center w-full lg:max-w-[31%] bg-white py-6 lg:py-10 px-8 border rounded-lg border-gray">
              <div className="flex justify-center flex-col-reverse items-center">
                <div></div>
                <img
                  decoding="async"
                  src="/images/solution/img_solution05.webp"
                  alt=""
                  className="w-auto h-full"
                />
              </div>
              <h3 className="text-center text-lg text-primary font-bold mt-0 lg:mt-2">
                D1-LAWGUE
              </h3>
              <p className="text-center text-sm lg:text-base text-textblack mt-3">
                次世代クラウドエディタで行政文書のDXを推進します
              </p>
              <p className="mt-4 text-center base_button_d1link">
                <Link
                  href="https://d1.lawgue.com/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="block text-center transition hover:text-secondary hover:border-secondary base_button linkbutton__large button__hidden"
                >
                  詳しく見る
                </Link>
              </p>
            </div>
          </div>
        )}
        {pathname === '/regulation/' && (
          <div className="flex flex-wrap justify-center gap-10 mt-6 lg:mt-14">
            <div className="w-full lg:max-w-[31%] bg-white py-6 lg:py-10 px-8 border rounded-lg border-gray text-center">
              <div className="flex justify-center flex-col-reverse items-center">
                <div></div>
                <img
                  decoding="async"
                  src="/images/solution/img_solution01.webp"
                  alt=""
                  className="w-auto h-full"
                />
              </div>

              <h3 className="text-center text-lg text-primary font-bold mt-0 lg:mt-2">
                契約ナレッジマネジメント
              </h3>

              <p className="text-center text-sm lg:text-base text-textblack mt-3">
                契約書業務の時間を大幅に
                <br />
                削減します
              </p>
              <Link
                href="/contract"
                className="pagescroll block base_button linkbutton__large button__hidden undefined transition hover:text-secondary hover:border-secondary mt-4 text-center"
              >
                詳しく見る
              </Link>
            </div>

            <div className="text-center w-full lg:max-w-[31%] bg-white py-6 lg:py-10 px-8 border rounded-lg border-gray">
              <div className="flex justify-center flex-col-reverse items-center">
                <div></div>
                <img
                  decoding="async"
                  src="/images/solution/img_solution04.webp"
                  alt=""
                  className="w-auto h-full"
                />
              </div>

              <h3 className="text-center text-lg text-primary font-bold mt-0 lg:mt-2">
                英文契約書レビュー
              </h3>

              <p className="text-center text-sm lg:text-base text-textblack mt-3">
                対訳辞書登録で正確な
                <br />
                翻訳を実現します
              </p>
              <Link
                href="/translation"
                className="pagescroll block base_button linkbutton__large button__hidden undefined transition hover:text-secondary hover:border-secondary mt-4 text-center"
              >
                詳しく見る
              </Link>
            </div>

            <div className="text-center w-full lg:max-w-[31%] bg-white py-6 lg:py-10 px-8 border rounded-lg border-gray">
              <div className="flex justify-center flex-col-reverse items-center">
                <div></div>
                <img
                  decoding="async"
                  src="/images/solution/img_solution03.webp"
                  alt=""
                  className="w-auto h-full"
                />
              </div>

              <h3 className="text-center text-lg text-primary font-bold mt-0 lg:mt-2">
                法令改正対応
              </h3>

              <p className="text-center text-sm lg:text-base text-textblack mt-3">
                最新の法改正情報を受け取り
                <br />
                法改正に迅速に対応します
              </p>
              <Link
                href="/law"
                className="pagescroll block base_button linkbutton__large button__hidden undefined transition hover:text-secondary hover:border-secondary mt-4 text-center"
              >
                詳しく見る
              </Link>
            </div>

            <div className="text-center  w-full lg:max-w-[31%] bg-white py-6 lg:py-10 px-8 border rounded-lg border-gray">
              <div className="flex justify-center flex-col-reverse items-center">
                <div></div>
                <img
                  decoding="async"
                  src="/images/solution/img_solution05.webp"
                  alt=""
                  className="w-auto h-full"
                />
              </div>

              <h3 className="text-center text-lg text-primary font-bold mt-0 lg:mt-2">
                D1-LAWGUE
              </h3>

              <p className="text-center text-sm lg:text-base text-textblack mt-3">
                次世代クラウドエディタで行政文書のDXを推進します
              </p>

              <p className="mt-4 text-center base_button_d1link">
                <Link
                  href="https://d1.lawgue.com/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="block text-center transition hover:text-secondary hover:border-secondary base_button linkbutton__large button__hidden"
                >
                  詳しく見る
                </Link>
              </p>
            </div>
          </div>
        )}
        {pathname === '/translation/' && (
          <div className="flex flex-wrap justify-center gap-10 mt-6 lg:mt-14">
            <div className="text-center w-full lg:max-w-[31%] bg-white py-6 lg:py-10 px-8 border rounded-lg border-gray">
              <div className="flex justify-center flex-col-reverse items-center">
                <div></div>
                <img
                  decoding="async"
                  src="/images/solution/img_solution01.webp"
                  alt=""
                  className="w-auto h-full"
                />
              </div>

              <h3 className="text-center text-lg text-primary font-bold mt-0 lg:mt-2">
                契約ナレッジマネジメント
              </h3>

              <p className="text-center text-sm lg:text-base text-textblack mt-3">
                契約書業務の時間を大幅に
                <br />
                削減します
              </p>
              <Link
                href="/contract"
                className="pagescroll block base_button linkbutton__large button__hidden undefined transition hover:text-secondary hover:border-secondary mt-4 text-center"
              >
                詳しく見る
              </Link>
            </div>

            <div className="text-center w-full lg:max-w-[31%] bg-white py-6 lg:py-10 px-8 border rounded-lg border-gray">
              <div className="flex justify-center flex-col-reverse items-center">
                <div></div>
                <img
                  decoding="async"
                  src="/images/solution/img_solution02.webp"
                  alt=""
                  className="w-auto h-full"
                />
              </div>

              <h3 className="text-center text-lg text-primary font-bold mt-0 lg:mt-2">
                規程・マニュアル管理
              </h3>

              <p className="text-center text-sm lg:text-base text-textblack mt-3">
                規程管理をクラウドで
                <br />
                効率化できます
              </p>
              <Link
                href="/regulation"
                className="pagescroll block base_button linkbutton__large button__hidden undefined transition hover:text-secondary hover:border-secondary mt-4 text-center"
              >
                詳しく見る
              </Link>
            </div>

            <div className="text-center w-full lg:max-w-[31%] bg-white py-6 lg:py-10 px-8 border rounded-lg border-gray">
              <div className="flex justify-center flex-col-reverse items-center">
                <div></div>
                <img
                  decoding="async"
                  src="/images/solution/img_solution03.webp"
                  alt=""
                  className="w-auto h-full"
                />
              </div>

              <h3 className="text-center text-lg text-primary font-bold mt-0 lg:mt-2">
                法令改正対応
              </h3>

              <p className="text-center text-sm lg:text-base text-textblack mt-3">
                最新の法改正情報を受け取り
                <br />
                法改正に迅速に対応します
              </p>
              <Link
                href="/law"
                className="pagescroll block base_button linkbutton__large button__hidden undefined transition hover:text-secondary hover:border-secondary mt-4 text-center"
              >
                詳しく見る
              </Link>
            </div>

            <div className="text-center w-full lg:max-w-[31%] bg-white py-6 lg:py-10 px-8 border rounded-lg border-gray">
              <div className="flex justify-center flex-col-reverse items-center">
                <div></div>
                <img
                  decoding="async"
                  src="/images/solution/img_solution05.webp"
                  alt=""
                  className="w-auto h-full"
                />
              </div>

              <h3 className="text-center text-lg text-primary font-bold mt-0 lg:mt-2">
                D1-LAWGUE
              </h3>

              <p className="text-center text-sm lg:text-base text-textblack mt-3">
                次世代クラウドエディタで行政文書のDXを推進します
              </p>

              <p className="mt-4 text-center base_button_d1link">
                <Link
                  href="https://d1.lawgue.com/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="block text-center transition hover:text-secondary hover:border-secondary base_button linkbutton__large button__hidden"
                >
                  詳しく見る
                </Link>
              </p>
            </div>
          </div>
        )}
      </div>
    </section>
  )
}
